"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateChangePassword = exports.validateForgotPassword = undefined;

var _revalidate = require("revalidate");

var _emailValidator = require("email-validator");

var isValidEmail = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!(0, _emailValidator.validate)(value)) {
      return message;
    }
  };
}, function (field) {
  return field + " doesn't seem to be valid";
});

var notMatchesField = function notMatchesField(otherField, otherFieldLabel) {
  return (0, _revalidate.createValidator)(function (message) {
    return function (value, allValues) {
      if (!allValues || value === allValues[otherField]) {
        return message;
      }
    };
  }, function (field) {
    return field + " must not be the same as " + otherFieldLabel;
  });
};

var validate = (0, _revalidate.combineValidators)({
  email: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidEmail)("Email"),

  password: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(6 - 1))({
    message: "Must be 6 or more characters"
  })
});

exports.default = validate;


var validateForgotPassword = (0, _revalidate.combineValidators)({
  email: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidEmail)("Email")
});

var validateChangePassword = (0, _revalidate.combineValidators)({
  oldPassword: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(6 - 1))("Old password"),
  password: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(6 - 1), notMatchesField("oldPassword")({
    message: "Your new password must be different from your old password"
  }))("Password"),
  repeatPassword: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(6 - 1), (0, _revalidate.matchesField)("password")({
    message: "Make sure this is the same as your new password"
  }))("Confirm password")
});

exports.validateForgotPassword = validateForgotPassword;
exports.validateChangePassword = validateChangePassword;


//////////////////
// WEBPACK FOOTER
// ./src/utils/loginFormValidation.js
// module id = 425
// module chunks = 0